<template>
  <svg
    width="32"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M19.5313 9.82568C18.9966 9.82568 18.5626 10.2533 18.5626 10.7823C18.5626 14.3554 15.6186 17.2627 12.0005 17.2627C8.38136 17.2627 5.43743 14.3554 5.43743 10.7823C5.43743 10.2533 5.00345 9.82568 4.46872 9.82568C3.93398 9.82568 3.5 10.2533 3.5 10.7823C3.5 15.0873 6.79945 18.6412 11.0318 19.1186V21.0434C11.0318 21.5714 11.4648 22 12.0005 22C12.5352 22 12.9692 21.5714 12.9692 21.0434V19.1186C17.2006 18.6412 20.5 15.0873 20.5 10.7823C20.5 10.2533 20.066 9.82568 19.5313 9.82568Z"
      fill="currentColor"></path>
    <path
      d="M11.8241 15.2171H12.1748C14.5772 15.2171 16.5263 13.2932 16.5263 10.9208V6.29727C16.5263 3.92287 14.5772 2 12.1748 2H11.8241C9.42171 2 7.47266 3.92287 7.47266 6.29727V10.9208C7.47266 13.2932 9.42171 15.2171 11.8241 15.2171Z"
      fill="currentColor"></path>
  </svg>
</template>
